/* eslint-disable no-param-reassign */
import Vue from 'vue';
import baseURL from '@/api/http-common';

let userObj = ((localStorage.getItem('telasUserObj') !== null) && (localStorage.getItem('telasUserObj').length > 0)) ? JSON.parse(localStorage.getItem('telasUserObj')) : '';
const telasAdminState = {
  emailTemplate: {},
  emailTemplateObj: {},
};
const getters = {
};
const actions = {
  async getEmailTemplate({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      const response = await Vue.axios.get(`${baseURL}extended-telasweb/v1/email-template`, { params: data });
      const actualData = response.data;
      commit('GETEMAILTEMPLATE', { actualData, rootState, origin });
    } catch (error) {
      if (error.response.data.length) {
        const actualData = error.response.data;
        commit('GETEMAILTEMPLATEERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async updateEmailTemplate({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      userObj = rootState.user.userDetails.length > 0 ? rootState.user.userDetails : userObj;
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(`${baseURL}extended-telasweb/v1/email-template`,
        data, options);
      const actualData = response.data;
      commit('GETEMAILTEMPLATE', { actualData, rootState, origin });
    } catch (error) {
      if (error.response.data.length) {
        const actualData = error.response.data;
        commit('GETEMAILTEMPLATEERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
};
const mutations = {
  GETEMAILTEMPLATE(state, { actualData }) {
    telasAdminState.emailTemplate = actualData;
  },
  // eslint-disable-next-line no-unused-vars
  GETEMAILTEMPLATEERROR(state, { actualData, rootState }) {
    // rootState.courses.courseDetails = actualData;
  },
  LOADING(state, { rootState }) {
    rootState.common.loading = true;
  },
  ENDLOADING(state, { rootState }) {
    rootState.common.loading = false;
  },
};

export default {
  namespaced: true,
  state: telasAdminState,
  getters,
  actions,
  mutations,
};
